<template>
  <div id="dashboard" class="dashboard" ref="dashboard">
    <Banner
      v-if="user"
      :avatar="user.avatar"
      :subtitle="user.firstName"
      :message="welcomeMessage"
    />
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-7 mb-30 content--col">
          <div class="block rounded-10 h-100 mb-0">
            <div
              class="block-content p-40 h-100 d-flex align-items-center position-relative"
              v-if="events"
            >
              <div class="flex-fill datepickers--wrapper">
                <div class="datepickers--form-group">
                  <p class="fz--mid">
                    Find your ideal workspace
                  </p>
                  <div class="row mx-0">
                    <div class="datepickers">
                      <DateTimePickerResponsive
                        ref="startDate"
                        label="When"
                        timeLabel="Start Time"
                        withIcon
                        v-model="schedStart"
                        :handleClearTime="handleClearTime"
                        :timeItems="startTimeItems"
                        :disabledDates="handleDisabledDate"
                        :disabledPreviousMonth="true"
                        :dateOnly="true"
                        :markedDateToday="true"
                        @apply="handleApply"
                        @close="handleClose"
                      />
                    </div>
                    <div class="datepicker-action">
                      <ActionButton
                        type="button"
                        class="submit-button"
                        :label="null"
                        :theme="actionButtonTheme"
                        @customEvent="handleMakeBookingClick"
                      >
                        <p>Search</p>
                      </ActionButton>
                    </div>
                  </div>
                </div>
                <div class="graphic-col">
                  <img
                    src="@/assets/media/backgrounds/coworkers.svg"
                    alt=""
                    class="graphic--booking"
                  />
                </div>
              </div>
            </div>
            <div class="p-10" v-else>
              <Spinner :theme="primary" />
            </div>
          </div>
        </div>
        <div class="col-lg-5 mb-30 col-slick">
          <div class="block rounded-10 mb-0">
            <div class="block-content p-0" v-if="events">
              <UserDashboardSlider v-if="events.length >= 2" :events="events" />
              <div v-else-if="events.length === 1" class="slide__item">
                <div class="slide__feat">
                  <img
                    :src="
                      events[0].featuredImage != null
                        ? events[0].featuredImage
                        : defaultImage
                    "
                    class="slide__img rounded-10 mw-100"
                    alt=""
                  />
                </div>
                <div class="slide__content">
                  <div class="slide__subtitle">Latest Events</div>
                  <h2 class="slide__title">{{ events[0].name }}</h2>
                  <p class="slide__description">
                    {{
                      events[0].formatedDescription | decode | limit(200, "")
                    }}
                  </p>
                  <router-link
                    :to="`${linkTextUrl + events[0].id}`"
                    class="slide__cta"
                    :style="{ color: primary }"
                  >
                    Learn More
                  </router-link>
                </div>
              </div>
            </div>
            <div class="p-10" v-else>
              <Spinner :theme="primary" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "@/components/ActionButton";
import Spinner from "@/components/Spinner";
import Banner from "@/components/banner/Avatar";
import UserDashboardSlider from "@/modules/user/pages/UserDashboardSlider";
import { addDays, format } from "date-fns";
import _ from "lodash";
import DateTimePickerResponsive from "@/components/datetimepicker/DateTimePickerResponsive.vue";

export default {
  name: "dashboard",
  components: {
    Banner,
    UserDashboardSlider,
    Spinner,
    DateTimePickerResponsive,
    ActionButton
  },
  computed: {
    startTimeItems() {
      const now = new Date();

      return Array.apply(null, { length: 48 }).map((time, index) => {
        const value = index.toString();
        const option = new Date(
          new Date(this.schedStart || now).setHours(0, index * 30, 0)
        );
        let isDisabled = false;

        return {
          value,
          name: format(option, "h:mm A"),
          disabled: isDisabled
        };
      });
    },
    events() {
      return this.$store.state.concierge.eventsList.data;
    },
    user() {
      return this.$store.getters.getUser;
    },
    options() {
      return this.$store.state.concierge.optionsList.data;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    categories() {
      this.$store.state.user.categories.map(category => {
        Object.assign(category, {
          label: category.name,
          value: category.id
        });
      });
      return this.$store.state.user.categories || [];
    }
  },
  async created() {
    const newSchedStart = addDays(new Date(), 1).toISOString();
    const formatDate = format(newSchedStart, "MMM DD, YYYY");

    this.schedEnd = new Date(`${formatDate} 12:00 AM`).toISOString();
    this.schedStart = new Date(`${formatDate} 12:00 AM`).toISOString();
    this.tempDate = new Date(`${formatDate} 12:00 AM`).toISOString();

    await this.$store.dispatch("fetchOptions", "support");
    let supportFilterWelcome = {
      key: "support.welcome"
    };
    this.isWelcomeSupportOption = _.filter(this.options, supportFilterWelcome);
    const welcomeMessageCheck =
      this.isWelcomeSupportOption.length &&
      this.isWelcomeSupportOption[0].value.message != "" &&
      this.isWelcomeSupportOption[0].value.message != null;

    this.welcomeMessage = welcomeMessageCheck
      ? this.isWelcomeSupportOption[0].value.message
      : "Let's do some amazing work today!";

    let params = {
      number: 1,
      size: 3
    };
    await this.$store.dispatch(
      "fetchRecentEvents",
      `events?page[number]=${params.number}&page[size]=${params.size}`
    );
  },
  data: () => ({
    isWelcomeSupportOption: {},
    welcomeMessage: "",
    defaultImage: require("@/assets/media/backgrounds/default.jpg"),
    linkTextUrl: "events/",
    isAnytime: true,
    data: {
      category: null
    },
    schedule: {
      startDate: null
    },
    schedStart: null,
    schedEnd: null,
    tempDate: null,
    actionButtonTheme: {
      primary: "#20c997"
    },
    windowWidth: window.innerWidth
  }),
  watch: {
    schedStart(newSched) {
      const date = new Date(newSched);
      this.schedule.startDate = format(date, "MMMM D, YYYY");
      this.schedEnd = new Date(
        `${format(date, "MMMM D, YYYY")} 11:59 PM`
      ).toISOString();

      if (this.windowWidth >= 640 && this.$refs.startDate)
        this.$refs.startDate.handleDismiss();
    }
  },
  mounted() {
    // Sets schedEnd to an hour ahead of schedStart
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },
  methods: {
    handleClearTime() {
      this.isAnytime = !this.isAnytime;
    },
    handleDisabledDate(date) {
      return (
        date.getTime() < new Date().getTime() &&
        date.toLocaleDateString() !== new Date().toLocaleDateString()
      );
    },
    formatDate(date, pattern = "MMM DD, YYYY h:mm A") {
      return format(new Date(date), pattern);
    },
    handleMakeBookingClick() {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.$router.push({
        name: "UserBookingV3",
        query: {
          startDate: this.schedStart,
          timeZone: timeZone,
          anytime: this.isAnytime
        }
      });
    },
    handleApply() {
      this.tempDate = this.schedStart;
    },
    handleClose() {
      this.schedStart = this.tempDate;
    }
  }
};
</script>

<style lang="scss" scoped>
.dashboard {
  &-img {
    position: absolute;
    right: 15px;
    width: 50%;
  }
  .fz--mid {
    font-family: $font-family-base;
    font-size: 1.5rem;
    line-height: 2.125rem;
    color: #4c4c4c;
    @media (max-width: 767px) {
      br {
        display: none;
      }
    }
  }

  .datepickers {
    width: 100%;

    /deep/ .dt-output {
      font-size: 0.875rem;
      white-space: unset;
      padding: 0.625rem 1rem;
    }

    &--wrapper {
      display: flex;
      align-items: center;
      flex-direction: column;
      flex-wrap: nowrap;

      @media screen and (min-width: 640px) {
        flex-direction: row;
      }

      @media screen and (min-width: 1200px) {
        align-items: flex-start;
      }
    }

    &--form-group {
      @media screen and (max-width: 639px) {
        width: 100%;
      }

      @media screen and (min-width: 640px) {
        flex: 1 1 58.33333%;
      }
      @media screen and (min-width: 1280px) {
        width: 360px;
        padding-top: 18px;
      }
    }
  }

  .graphic-col {
    @media screen and (max-width: 639px) {
      width: 100%;
    }
    @media screen and (min-width: 640px) {
      flex: 0 0 41.66667%;
      max-width: 41.66667%;
      margin-left: 15px;
    }
    @media screen and (min-width: 1280px) {
      flex: 1 1 auto;
      max-width: unset;
      margin-left: 48px;
    }
  }

  .datepicker-action {
    display: flex;
    width: 100%;
    padding-top: 8px;

    .submit-button {
      width: 100%;
      margin-top: 0px;
      padding: 11px 16px;
      margin: 0;
      border-radius: 4px;

      p {
        margin: 0;
        font-family: "Nunito Sans";
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
      }
    }

    @media screen and (min-width: 640px) {
      justify-content: flex-end;

      .submit-button {
        width: max-content;
      }
    }
  }
  .content--col {
    @media (max-width: 575px) {
      margin-left: 5px;
      margin-right: 5px;
    }

    @media screen and (min-width: 1440px) {
      width: 856px;
      max-width: 856px;
      padding: 0;
    }
  }
  .col-slick {
    @media screen and (min-width: 1440px) {
      width: 480px;
      max-width: 480px;
    }
  }
  .graphic--booking {
    height: auto;
    margin: 16px auto 0;

    @media screen and (min-width: 992px) {
      height: 250px;
      margin: 0 auto 0;
    }

    @media screen and (min-width: 1280px) {
      height: 322px;
    }
  }
  .slide__item {
    .slide__feat {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      max-height: 245px;
      overflow: hidden;
      position: relative;
      @include media-breakpoint-down(md) {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        height: 400px;
        .slide__img {
          height: 100%;
          object-fit: cover;
        }
      }
      .slide__img {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        width: 100%;
      }
    }
    .slide__content {
      padding: 18px 40px;
      .slide__subtitle {
        color: #a1a1a1;
        font-family: $font-family-base;
        font-size: 15px;
        line-height: 26px;
        margin-bottom: 5px;
      }
      .slide__title {
        font-family: $font-family-base;
        font-size: 20px;
        font-weight: 500;
        line-height: 26px;
        margin-bottom: 12px;
      }
      .slide__description {
        font-family: $font-family-base;
        line-height: 24px;
        margin-bottom: 15px;
        font-size: 14px;
      }
      .slide__cta {
        color: #51b67e;
        display: block;
        font-family: $font-family-base;
        line-height: 24px;
      }
    }
  }
}

.v-select {
  max-width: 270px;
}
@-moz-document url-prefix() {
  .block-content {
    overflow-x: hidden !important;
  }
}
</style>
